function getKnowledgeUrl() {
  return 'https://knowledge.hubspot.com';
}
export default getKnowledgeUrl;